import { createFeatureSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { IRouterStateUrl, FEATURE_NAME } from './state';

export const routerSelector = createFeatureSelector<RouterReducerState<IRouterStateUrl>>(FEATURE_NAME);
